import {
  ButtonSkinAbsoluteBlack,
  ButtonSkinPrimary,
  ButtonSkinSecondary,
  ButtonVariants,
} from '@picsart/design-system/components/Button';

export const getButtonOption = buttonColorVariant => {
  const buttonConfigurations = {
    Primary: {
      name: 'Primary',
      skin: ButtonSkinPrimary,
      variant: ButtonVariants.Filled,
    },
    Secondary: {
      name: 'Secondary',
      skin: ButtonSkinSecondary,
      variant: ButtonVariants.Filled,
    },
    Black: {
      name: 'Black',
      skin: ButtonSkinAbsoluteBlack,
      variant: ButtonVariants.Text,
    },
    Hyperlink: {
      name: 'Hyperlink',
      skin: ButtonSkinPrimary,
      variant: ButtonVariants.Text,
    },
  };

  return buttonColorVariant
    ? buttonConfigurations[buttonColorVariant]
    : buttonConfigurations.Primary;
};
